export const IDENTITY_SESSION_COOKIE_NAME = "duet:identitySession";
export const IDENTITY_EXPIRES_IN = 60 * 60 * 24 * 14 * 1000; // 14 days in milliseconds

export const IDENTITY_ENTITLEMENTS_COOKIE_NAME = "duet:identityEntitlements";
export const IDENTITY_CORAL_COOKIE_NAME = "duet:identityCoral";
export const IDENTITY_ENTITLEMENTS_EXPIRES_IN = 60 * 60 * 24; // 24 hours in seconds

export const IDENTITY_REFRESH_COOKIE_NAME = "duet:identityRefresh";
export const IDENTITY_REFRESH_EXPIRES_IN = 60 * 60 * 24 * 90 * 1000; // 90 days in milliseconds, ~3 months

export const IDENTITY_CSRF_COOKIE_NAME = "duet:identityCsrf";

// A cookie available to client to check authenticated status before verifying it server-side.
export const IDENTITY_AUTHENTICATED_COOKIE_NAME = "duet:identityAuthenticated";

export const IDENTITY_SESSION_CACHE_TTL_IN_SECONDS = 90 * 24 * 60 * 60; // 90 days in seconds
export const IDENTITY_SESSION_CACHE_TTL_IN_MS =
  IDENTITY_SESSION_CACHE_TTL_IN_SECONDS * 1000; // 90 days in milliseconds

export const IDENTITY_SESSION_CACHE_PREFIX = "session";
export const IDENTITY_USER_CACHE_PREFIX = "user";
export const IDENTITY_SESSIONS_CACHE_PREFIX = "user:sessions";

// SSO
export const IDENTITY_SSO_TOKEN_PREFIX = "identity:sso_token";
export const IDENTITY_SSO_TOKEN_TTL_IN_SECONDS = 30;

export const RETIRED_NETWORK_DOMAINS = ["polygon.com"];
